import { Row } from '@tanstack/react-table';
import { ExpandButton } from '../ui';

interface Props<T> {
  row: Row<T>;
  hasMultipleSchedules: boolean;
}

export default function ExpandCell<T>({ row, hasMultipleSchedules }: Props<T>) {
  if (!hasMultipleSchedules) return null;
  return <ExpandButton row={row} />;
}
